import DtoAccountStatistic from './DtoAccountStatistic'

export default class DtoAccountUsageStatistic extends DtoAccountStatistic {
    constructor(obj) {
        super(obj)
    }
}